//var basepath= 'http://120.27.13.102:8081/phoenix_tv'
var basepath = 'http://106.38.70.199:8080/phoenix_tv'
//var basepath = '/phoenix_tv'
export default {
  userLogin:basepath + '/user/login',
  logout:basepath + '/user/logout',
  uploadNetworkHead:basepath + '/user/uploadNetworkHead',
  uploadSignPic:basepath + '/user/uploadSignPic',
  userDetail:basepath + '/user/userDetail',
  addOrUpdateUser:basepath + '/user/addOrUpdateUser',
  getAllUser:basepath + '/user/getAllUser',
  userList:basepath + '/user/userList',
  trunOnOrOff:basepath + '/user/trunOnOrOff',
  userDetailForSuper:basepath + '/user/userDetailForSuper',
  userTypeList:basepath + '/user/userTypeList',
  resetPwd:basepath + '/user/resetPwd',
  modifyPwd:basepath + '/user/modifyPwd',
  commonUserUpdate:basepath +'/user/commonUserUpdate',

  menuList:basepath + '/menu/menuList',

  postJobList:basepath + '/post-job/postJobList',

  officeList:basepath + '/represent-office/repOfficeList',
  getAreaList:basepath + '/represent-office/getAreaListByrepresentId',
  repOfficeList:basepath + '/represent-office/repOfficeList',
  addOrUpdateRepOffice:basepath + '/represent-office/addOrUpdateRepOffice',

  departList:basepath + '/department/departList',

  manageList:basepath + '/notice/manageList',
  deleteById:basepath + '/notice/deleteById',
  listPage:basepath + '/notice/listPage',
  doRead:basepath+'/notice/doRead',
  getNoticeById:basepath + '/notice/getNoticeById',
  getReadUnread:basepath + '/notice/getReadUnread',
  getAllNoticeType:basepath + '/notice/getAllNoticeType',
  addOrUpdateNotice:basepath + '/notice/addOrUpdate',

  uploadFile:basepath + '/file/upload',
  download:basepath + '/file/download',
  removeFile:basepath + '/file-manage/removeFile',

  roleList:basepath + '/role/roleList',
  roleListWithMenuList:basepath + '/role/roleListWithMenuList',
  addOrUpdateRole:basepath + '/role/addOrUpdateRole',

  clientsList:basepath + '/clients/clientsList',
  clientsAuditList:basepath + '/clients/clientsAuditList',
  clientDetails:basepath + '/clients/clientDetails',
  clientCategory:basepath + '/clients/clientCategory',
  getIntergrationTypeEnumList:basepath + '/clients/getIntergrationTypeEnumList',
  getAreaTypeEnumList:basepath + '/clients/getAreaTypeEnumList',
  addClientClients:basepath + '/clients/addClientClients',
  clientUpdateAudit:basepath + '/clients/clientUpdateAudit',
  updateClientClients:basepath + '/clients/updateClientClients',
  closeClientView:basepath + '/clients/closeClientView',
  openClientView:basepath + '/clients/openClientView',
  clientGetVodTypeEnumList:basepath + '/clients/getVodTypeEnumList',
  getClientSourceEnumList:basepath + '/clients/getClientSourceEnumList',
  updateClientDigital:basepath + '/clients/updateClientDigital',
  addClientDigital:basepath + '/clients/addClientDigital',


  getChannelTypeList:basepath + '/clientStatic/getChannelTypeList',
  getWeiduList:basepath + '/clientStatic/getWeiduList',
  getYearTaskList:basepath + '/clientStatic/getYearTaskList',
  getSummaryList:basepath + '/clientStatic/getSummaryList',
  getIncreaseList:basepath + '/clientStatic/getIncreaseList',
  getYearProgressList:basepath + '/clientStatic/getYearProgressList',
  getYearMonthProgressList:basepath + '/clientStatic/getYearMonthProgressList',
  getMonthProgressList:basepath + '/clientStatic/getMonthProgressList',
  getClientStatisClassList:basepath + '/clientStatic/getClientStatisClassList',
  addClientView:basepath + '/clients/addClientView',
  deleteClientDigital:basepath + '/clients/deleteClientDigital',
  getClientChange:basepath + '/clientStatic/getClientChange',
  summaryTask: basepath +'/clientStatic/summaryTask',
  importYearTask: basepath +'/clientStatic/importYearTask',
  getMonthMonthProgressList:basepath+'/clientStatic/getMonthMonthProgressList',

  areaList:basepath + '/area/areaList',
  areaListAuth:basepath+'/area/areaListAuth',

  getFileList:basepath + '/file-manage/getFileList',
  fileTypeList:basepath + '/file-manage/fileTypeList',
  fileManageUpload:basepath + '/file-manage/uploadFile',

  updateContacts:basepath + '/contacts/updateContacts',
  addContacts:basepath + '/contacts/addContacts',

  getMovTypeList:basepath + '/agentinfo/getMovTypeList',
  getPlatformTypeList:basepath + '/movieclient/getPlatformTypeList',
  getAccrediTypeEnumList:basepath + '/movieclient/getAccrediTypeEnumList',
  movieClientList:basepath + '/movieclient/movieClientList',
  movieAuditList:basepath + '/movieclient/movieAuditList',
  movieUpdateAudit:basepath + '/movieclient/movieUpdateAudit',
  movieClientDetails:basepath + '/movieclient/movieClientDetails',
  updateMovieClient:basepath + '/movieclient/updateMovieClient',
  updateMovieCompactmoney:basepath + '/movieclient/updateMovieCompactmoney',

  getagent:basepath + '/agentinfo/getagent',
  agentinfoList:basepath + '/agentinfo/agentinfoList',
  deleteagent:basepath + '/agentinfo/deleteagent',
  addagent:basepath + '/agentinfo/addagent',
  updateAgent:basepath + '/agentinfo/updateAgent',
  agentInfo:basepath + '/agentinfo/agentInfo',



  getInSight:basepath + '/movieStat/getInSight',
  moneyStats:basepath + '/movieStat/moneyStats',
  payStats:basepath + '/movieStat/payStats',
  contractStats:basepath + '/movieStat/contractStats',
  addMovieClient:basepath + '/movieclient/addMovieClient',
  openmovie:basepath + '/movieclient/openmovie',
  closemovie:basepath + '/movieclient/closemovie',
  addMovieContract:basepath + '/movieclient/addMovieContract',
  deleteContract:basepath + '/movieclient/deleteContract',
  updateMovieContract:basepath + '/movieclient/updateMovieContract',
  deleteCompactmoney:basepath + '/movieclient/deleteCompactmoney',
  addMovieCompactmoney:basepath + '/movieclient/addMovieCompactmoney',

  templateAll:basepath + '/template/getAll',
  addOrUpdate:basepath + '/template/addOrUpdate',

  processAll:basepath +'/process/list/getAll',
  addProcessNodesUsers:basepath + '/process/addProcessNodesUsers',
  getNodeList:basepath + '/process/getProcessDetail',
  updateProcessNodesUsers:basepath + '/process/updateProcessNodesUsers',

  getCsmWeiduList:basepath + '/csm-task/getCsmWeiduList',
  getCsmYearTask:basepath + '/csm-task/getCsmYearTask',
  getCsmOriginal:basepath + '/csm-task/getCsmOriginal',
  getCsmWeighted:basepath + '/csm-task/getCsmWeighted',
  getCsmYearProcess:basepath + '/csm-task/getCsmYearProcess',
  getCsmYearProcessMonth:basepath + '/csm-task/getCsmYearProcessMonth',
  getCsmMonthProcess:basepath + '/csm-task/getCsmMonthProcess',
  getCsmMonthProcessMonth:basepath + '/csm-task/getCsmMonthProcessMonth',
  importCSMOriginal:basepath + '/csm-task/importCSMOriginal',
  importCSMYearTask:basepath + '/csm-task/importCSMYearTask',

  applyList:basepath + '/template-data/applyList/boss',
  applyDetail:basepath + '/template-data/applyDetail/get',
  myApplyList:basepath + '/template-data/myApplyList',
  addApply:basepath + '/template-data/applyDetail/add',
  approve:basepath + '/template-data/leaveDetail/approve',
  see:basepath + '/template-data/leaveDetail/see',
  pishi:basepath + '/template-data/leaveDetail/pishi',

  getIntegratedYearProcess:basepath + '/integrated-process/getIntegratedYearProcess',
  getIntegratedMonthProcess:basepath + '/integrated-process/getIntegratedMonthProcess',

  movieAuditExport:basepath +'/excel/movieAuditExport',
  agentinfoExport:basepath + '/excel/agentinfoExport',
  inSightExport:basepath + '/excel/inSightExport',
  moneyStatsExport:basepath + '/excel/moneyStatsExport',
  payStatsExport:basepath + '/excel/payStatsExport',
  contractStatsExport:basepath + '/excel/contractStatsExport',
  movieClientListExport:basepath + '/excel/movieClientListExport',
  clientExport:basepath + '/excel/clientExport',
  clientAuditExport:basepath + '/excel/clientAuditExport',

  getCsmYearTaskExcel:basepath +'/csm-export/getCsmYearTaskExcel',
  getCsmOriginalExcel:basepath +'/csm-export/getCsmOriginalExcel',
  getCsmWeightedExcel:basepath + '/csm-export/getCsmWeightedExcel',
  getCsmYearProcessExcel:basepath + '/csm-export/getCsmYearProcessExcel',
  getCsmYearProcessMonthExcel:basepath + '/csm-export/getCsmYearProcessMonthExcel',
  getCsmMonthProcessExcel:basepath + '/csm-export/getCsmMonthProcessExcel',
  getCsmMonthProcessMonthExcel:basepath + '/csm-export/getCsmMonthProcessMonthExcel',

  getYearTaskListExport:basepath + '/clientStaticExport/getYearTaskListExport',
  getSummaryListExcel:basepath + '/clientStaticExport/getSummaryListExcel',
  getIncreaseListExcel:basepath +'/clientStaticExport/getIncreaseListExcel',
  getYearProgressListExcel:basepath + '/clientStaticExport/getYearProgressListExcel',
  getYearMonthProgressListExcel:basepath + '/clientStaticExport/getYearMonthProgressListExcel',
  getClientChangExcel:basepath + '/clientStaticExport/getClientChangExcel',
  getClientStatisClassListExcel:basepath + '/clientStaticExport/getClientStatisClassListExcel',
  getClientStatisClassListPercExcel:basepath + '/clientStaticExport/getClientStatisClassListPercExcel',
  getMonthProgressListExcel: basepath +'/clientStaticExport/getMonthProgressListExcel',
  getMonthMonthProgressListExcel:basepath + '/clientStaticExport/getMonthMonthProgressListExcel',

  phtvList:basepath+'/phDivision/phtvList',
  getVodTypeEnumList:basepath+ '/phDivision/getVodTypeEnumList',
  addPhtv:basepath+'/phDivision/addPhtv',
  updatePhtv:basepath+ '/phDivision/updatePhtv',

  getAttendanceList:basepath+ '/attendance/getList',
  importAttendance:basepath+'/attendance/import',
}
